.cartesian-chart {
  display: grid;
  place-self: center;
  margin: var(--mantine-spacing-xs);
}

.chart {
  margin: auto;
}

.tooltip {
  :global {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-xs);
    font-size: var(--mantine-font-size-sm);
    white-space: nowrap;
    background-color: alpha(var(--mantine-color-dark-6), 0.2);
    border: 1px solid var(--mantine-color-dark-4);
    border-radius: var(--mantine-radius-sm);
    box-shadow: var(--mantine-shadow-sm), var(--mantine-shadow-lg);
    backdrop-filter: blur(var(--mantine-radius-md));
    .recharts-tooltip-label {
      font-size: var(--mantine-font-size-lg);
      font-weight: 600;
    }
    .recharts-tooltip-item-list {
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: var(--mantine-spacing-xs);
      align-items: baseline;
    }
    .recharts-tooltip-item {
      display: contents;
      padding: 0;
    }
    .recharts-tooltip-item-name {
      &::before {
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        margin-inline-end: var(--mantine-spacing-xs);
        vertical-align: center;
        content: '';
        background: currentColor;
      }
    }
    .recharts-tooltip-item-separator {
      display: none;
    }
    .recharts-tooltip-item-value {
      font-weight: 600;
      color: var(--mantine-color-dark-0);
    }
    .recharts-tooltip-item-unit {
      font-size: var(--mantine-font-size-xs);
      color: var(--mantine-color-dark-0);
    }
  }
}
